import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { CONFIG_NAMES } from '../../utils/AuthUtils';
import { isSupplierInventoryConfigEnabled } from '../common/SupplierInventoryConfigPermissionChecker';
import OverviewShell from '../overview_shell/OverviewShell';

const style = require('./PurchaseRequestsOverviewPage.less');

const PurchaseRequestsOverviewPage: FC<any> = ({
	history,
	companyConfig,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/supplier/purchaseRequests/overview/${key}`),
		[history]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const poDisabled = isSupplierInventoryConfigEnabled(
		companyConfig,
		CONFIG_NAMES.DISABLE_PURCHASE_ORDERS
	);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
		{
			key: 'requests',
			name: 'Request List',
		},
		...(!poDisabled
			? [
					{
						key: 'approved',
						name: 'Approved Requests',
					},
					{
						key: 'readyToOrder',
						name: 'Ready To Order',
					},
			  ]
			: []),
	];

	return (
		<>
			<Route
				path="/supplier/purchaseRequests/overview"
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: '/supplier/purchaseRequests/overview/all',
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Purchase Requests"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="purchaseRequestsPage"
			/>
		</>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
});
const mapDispatchToProps = (dispatch) => ({});

export default withRouter<any, any>(
	connect(mapStateToProps, mapDispatchToProps)(PurchaseRequestsOverviewPage)
);
